// extracted by mini-css-extract-plugin
export default {"container":"ok-z","bubbleNav":"pk-z","graphic":"qk-z","contact":"rk-z"};